var _path, _path2, _path3, _path4, _g, _g2, _g3, _path5, _path6, _path7, _path8, _path9, _g4, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1008px",
    height: "612px",
    viewBox: "0 0 1008 612",
    enableBackground: "new 0 0 1008 612",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone_book") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stickers",
    display: "none"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 374.0349,
    cy: 369.9724,
    r: 55.6209,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A6E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00599C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_1_)",
    d: "M709.295,281.664h30.182c5.168-0.073,9.417,4.057,9.49,9.226 c0.001,0.088,0.001,0.177,0,0.265v58.702c-0.039,5.226-4.266,9.452-9.49,9.491h-30.242c-5.225-0.039-9.451-4.266-9.49-9.491 v-58.714c-0.067-5.169,4.068-9.413,9.236-9.48C709.086,281.661,709.19,281.661,709.295,281.664z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 374.0344,
    cy: 435.4246,
    r: 49.76,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBD3CE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EBE50A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_2_)",
    d: "M709.295,197.167h30.229c5.242,0,9.491,4.249,9.491,9.491v58.689 c0,5.241-4.249,9.491-9.491,9.491h-30.229c-5.242,0-9.491-4.25-9.491-9.491v-58.689 C699.804,201.416,704.053,197.167,709.295,197.167z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 377.4744,
    cy: 504.3123,
    r: 51.7117,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00652E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_3_)",
    d: "M709.295,113.268h30.229c5.242,0,9.491,4.249,9.491,9.49v58.689 c0,5.242-4.249,9.491-9.491,9.491h-30.229c-5.242,0-9.491-4.249-9.491-9.491v-58.689 C699.804,117.517,704.053,113.268,709.295,113.268z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 201.803,
    cy: 514.6541,
    r: 366.5341,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M385.557,47.155h265.634c38.25,0,69.962,29.883,69.962,66.412v332.619 c0,36.457-31.724,66.412-69.962,66.412H385.557c-38.537,0-69.962-29.943-69.962-66.412V113.554 C315.595,77.097,347.02,47.155,385.557,47.155z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "oppening"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M394.162,59.909h248.135c35.859,0,65.229,23.416,65.229,52.176v1.195 c-5.94-24.026-32.596-42.398-64.344-42.398H393.565c-32.022,0-58.701,18.385-64.63,42.398v-1.195 C328.935,83.325,358.291,59.909,394.162,59.909z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "handle",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M502.075,240.748c-4.605,16.343-4.914,33.599-0.896,50.096 c4.065,15.971,12.123,30.646,23.416,42.648c7.71,8.308,10.076,9.192,13.041,20.751l9.49,39.445 c3.264,13.041,3.861,18.085-10.674,11.271c-37.354-17.487-68.479-54.841-80.337-102.868c-12.156-48.327-2.08-96.343,23.129-129.847 c7.71-10.077,10.077-11.272,13.34,1.78l10.675,42.1C505.924,227.707,505.326,229.5,502.075,240.748z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M501.179,155.39l26.081-6.526c4.57-1.049,9.152,1.701,10.376,6.228l16.005,64.332 c1.056,4.571-1.697,9.157-6.228,10.375l-26.094,6.526c-4.529,1.179-9.157-1.538-10.335-6.067c-0.014-0.054-0.027-0.106-0.04-0.16 l-16.018-64.032C493.79,161.403,496.557,156.679,501.179,155.39z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M544.76,329.978l26.094-6.526c4.537-1.174,9.168,1.554,10.341,6.092 c0.012,0.045,0.023,0.09,0.034,0.136l16.006,64.033c1.146,4.655-1.611,9.38-6.229,10.674l-26.045,6.526 c-4.571,1.056-9.157-1.697-10.376-6.228l-16.017-64.332C537.517,335.795,540.248,331.218,544.76,329.978z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "shadow",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,163.376c13.915,0.165,25.329-10.982,25.494-24.897s-10.981-25.329-24.896-25.494 s-25.329,10.981-25.494,24.896c-0.001,0.1-0.002,0.198-0.002,0.298c-0.152,13.763,10.883,25.044,24.646,25.195 C359.306,163.375,359.391,163.376,359.475,163.376z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,234.281c13.833-0.907,24.313-12.856,23.405-26.689 c-0.824-12.569-10.836-22.582-23.405-23.406c-13.834,0.907-24.313,12.857-23.405,26.69 C336.894,223.445,346.906,233.457,359.475,234.281z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,305.379c13.916,0,25.197-11.281,25.197-25.197s-11.281-25.197-25.197-25.197 s-25.197,11.281-25.197,25.197S345.559,305.379,359.475,305.379z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,376.224c13.833-0.906,24.313-12.856,23.405-26.689 c-0.824-12.569-10.836-22.581-23.405-23.405c-13.834,0.907-24.313,12.856-23.405,26.689 C336.894,365.388,346.906,375.401,359.475,376.224z"
  }), /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#231F20",
    d: "M359.475,447.382c13.862,0.112,25.191-11.035,25.304-24.897 c0.112-13.863-11.035-25.191-24.897-25.304c-13.863-0.112-25.192,11.035-25.304,24.897c-0.001,0.036-0.001,0.071-0.001,0.106 c-0.146,13.771,10.899,25.051,24.67,25.196C359.323,447.382,359.399,447.382,359.475,447.382z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "wire",
    display: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 487.0925,
    x2: 30.8562,
    y2: 523.0336,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_5_)",
    d: "M281.504,117.14h72.341c12.443,0,22.531,9.491,22.531,21.349l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442-0.024-22.543-9.515-22.543-21.373l0,0 C258.961,126.607,269.062,117.14,281.504,117.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 428.533,
    x2: 30.8562,
    y2: 464.5037,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_6_)",
    d: "M281.504,187.664h72.341c12.443,0,22.531,9.778,22.531,21.647l0,0 c0,11.559-10.076,21.349-22.531,21.349h-72.341c-12.442,0.035-22.543-9.778-22.543-21.337l0,0 C258.961,197.466,269.062,187.664,281.504,187.664z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 366.533,
    x2: 30.8562,
    y2: 402.463,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_7_)",
    d: "M281.504,258.534h72.341c12.443,0,22.531,9.491,22.531,21.349l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442-0.013-22.543-9.491-22.543-21.349l0,0 C258.961,268.025,269.062,258.534,281.504,258.534z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8562,
    y1: 307.9714,
    x2: 30.8562,
    y2: 343.9304,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_8_)",
    d: "M281.504,329.094h72.341c12.443,0,22.531,9.777,22.531,21.636l0,0 c0,11.559-10.076,21.348-22.531,21.348h-72.341c-12.442,0-22.543-9.777-22.543-21.348l0,0 C258.961,338.871,269.062,329.094,281.504,329.094z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.8611,
    y1: 249.4104,
    x2: 30.8611,
    y2: 285.351,
    gradientTransform: "matrix(1.1953 0 0 -1.1953 280.7861 741.2467)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#737272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E7E8"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_9_)",
    d: "M281.504,399.94h72.341c12.443,0,22.531,9.49,22.531,21.348l0,0 c0,11.857-10.076,21.349-22.531,21.349h-72.341c-12.442,0-22.531-9.491-22.531-21.349l0,0 C258.961,409.43,269.062,399.94,281.504,399.94z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#0F1027",
    d: "M530,296.991c44.734,0,80.99-36.262,80.99-80.99s-36.256-80.99-80.99-80.99 s-80.99,36.262-80.99,80.99S485.266,296.991,530,296.991z M562.08,327.363h-64.16c-60.546,0-109.652,49.1-109.652,109.652 c0,12.11,9.82,21.938,21.93,21.938h239.616c12.11,0.018,21.918-9.789,21.918-21.938 C671.733,376.463,622.632,327.363,562.08,327.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FECB30",
    d: "M518,287.991c44.734,0,80.99-36.262,80.99-80.99s-36.256-80.99-80.99-80.99s-80.99,36.262-80.99,80.99 S473.266,287.991,518,287.991z M550.08,318.363h-64.16c-60.546,0-109.652,49.1-109.652,109.652c0,12.11,9.82,21.938,21.93,21.938 h239.616c12.11,0.018,21.918-9.789,21.918-21.938C659.733,367.463,610.632,318.363,550.08,318.363z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "About",
    display: "none"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M518.125,87.5c84.568,0,153,68.432,153,153s-68.432,153-153,153s-153-68.432-153-153 S433.616,87.5,518.125,87.5z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "shadow2",
    display: "inline",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M527.125,132.244c-9.204,9.024-24.743,41.298-27.971,94.131h56.036 C551.988,173.542,536.448,141.268,527.125,132.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M639.962,226.375c-6.275-37.354-30.624-68.288-63.65-84.126c9.145,22.688,15.121,51.853,16.914,84.126 H639.962z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M639.962,264.625H593.19c-1.793,32.273-7.77,61.416-16.878,84.127 C609.363,332.878,633.627,302.038,639.962,264.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M555.095,264.625h-56.06c3.347,52.953,18.886,85.227,28.09,94.191 C536.448,349.851,551.988,317.578,555.095,264.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M477.997,142.225c-32.99,15.897-57.375,46.855-63.71,84.149h46.772 C462.937,194.101,468.913,164.936,477.997,142.225z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M477.997,348.775c-9.084-22.711-15.061-51.877-16.854-84.15h-46.856 C420.622,302.038,445.007,332.878,477.997,348.775z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1751",
    d: "M679,480.849H403.6c-16.897,0-30.6-13.701-30.6-30.6c0-16.896,13.703-30.6,30.6-30.6H679V480.849z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_10_",
    cx: 518.1721,
    cy: 174.3093,
    r: 38.7311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_10_)",
    d: "M518.125,127.244c-9.204,9.024-24.743,41.298-27.971,94.131h56.036 C542.988,168.542,527.448,136.268,518.125,127.244z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 599.137,
    cy: 179.3118,
    r: 37.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_11_)",
    d: "M630.962,221.375c-6.275-37.354-30.624-68.288-63.65-84.126 c9.145,22.688,15.121,51.853,16.914,84.126H630.962z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 599.137,
    cy: 301.6882,
    r: 37.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_12_)",
    d: "M630.962,259.625H584.19c-1.793,32.273-7.77,61.416-16.878,84.127 C600.363,327.878,624.627,297.038,630.962,259.625z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 518.0647,
    cy: 306.7205,
    r: 38.7537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_13_)",
    d: "M546.095,259.625h-56.06c3.347,52.953,18.886,85.227,28.09,94.191 C527.448,344.851,542.988,312.578,546.095,259.625z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 437.1423,
    cy: 179.3,
    r: 37.3164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_14_)",
    d: "M468.997,137.225c-32.99,15.897-57.375,46.855-63.71,84.149h46.772 C453.937,189.101,459.913,159.936,468.997,137.225z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 437.1423,
    cy: 301.7,
    r: 37.3166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#004AAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#007AAA"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "url(#SVGID_15_)",
    d: "M468.997,343.775c-9.084-22.711-15.061-51.877-16.854-84.15h-46.856 C411.622,297.038,436.007,327.878,468.997,343.775z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#FECB30",
    d: "M670,475.849H394.6c-16.897,0-30.6-13.701-30.6-30.6c0-16.896,13.703-30.6,30.6-30.6H670 V475.849z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FECB30",
    d: "M518.125,87.5c84.568,0,153,68.432,153,153s-68.432,153-153,153s-153-68.432-153-153 S433.616,87.5,518.125,87.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.60d5346ae13026721024752242061ba3.svg";
export { ForwardRef as ReactComponent };